import { Tag } from 'antd'
import type { TagProps } from 'antd'
import { ScheduledZoneSuspensionStatus } from '~/gql/generated/graphql'
import { capitalize } from '~/utils'

const statusColourMap: Record<
  ScheduledZoneSuspensionStatus,
  NonNullable<TagProps['color']> // "success" | "processing" | "warning" | "default"
> = {
  [ScheduledZoneSuspensionStatus.cancelled]: 'warning',
  [ScheduledZoneSuspensionStatus.complete]: 'success',
  [ScheduledZoneSuspensionStatus.in_progress]: 'cyan',
  [ScheduledZoneSuspensionStatus.scheduled]: 'default',
}

type Props = {
  value: ScheduledZoneSuspensionStatus
}

export const ReasonTag: React.FC<{ value: string }> = ({ value }) => (
  <Tag>{capitalize(value.replace(/_/g, ' '))}</Tag>
)

export const SuspensionStatusTag: React.FC<Props> = ({ value }) => (
  <Tag color={statusColourMap[value]}>
    {capitalize(value.replace(/_/g, ' '))}
  </Tag>
)
